module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var constants = require('Constants.js').default;

    ; __append("\r\n\r\n\r\n<!-- Start release note bar -->\r\n<div id=\"releaseNoteBar\" class=\"releaseNoteContainer\" style=\"top: 0px; padding-left: 6px; display: none;\">\r\n    <div class=\"releaseNote\">\r\n        Note: This is an initial implementation of PerfectApps Designer in HTML5. &nbsp;&nbsp;Check\r\n        <a class=\"pfa\" href=\"")
    ; __append(escapeFn(constants.RELEASE_NOTES ))
    ; __append("\" target=\"_blank\">here</a>\r\n         to see what's new in PerfectApps production.\r\n\r\n        <span>[[ Development demo of HTML5 color picker: <input type=\"color\" /> ]]</span>\r\n\r\n\r\n        <div id=\"close\" class=\"closeNote\">\r\n            <div id=\"tooltip\" class=\"closeTooltip\" style=\"display: none;\">Hide</div>\r\n        </div>\r\n    </div>\r\n\r\n    <div><button style=\"padding-right: 6px; color: #FFFFFF;\" type=\"button\" class=\"close\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button></div>\r\n\r\n</div>\r\n<!-- End release note bar -->")
  }
  return __output;

}